import { nextTick, ref } from 'vue'

const BACK_TO_BOTTOM_THRESHOLD = 120
const SCROLLED_TO_BOTTOM_THRESHOLD = 10
const SCROLLED_TO_TOP_THRESHOLD = 10

export const useMessageScroll = ({ onScrollToTop } = {}) => {
  const scrollbarRef = ref(null)
  const showBackToBottom = ref(false)
  let previousScrollTop = 0

  const isScrolledToBottom = () => {
    const wrap = scrollbarRef.value?.wrapRef
    if (!wrap) return false

    return wrap.scrollTop + wrap.clientHeight >= wrap.scrollHeight - SCROLLED_TO_BOTTOM_THRESHOLD
  }

  const scrollToBottom = async (force = false) => {
    const shouldScrollToBottom = force || isScrolledToBottom()
    await nextTick()

    const wrap = scrollbarRef.value?.wrapRef
    if (!wrap || !shouldScrollToBottom) return

    scrollbarRef.value.setScrollTop(wrap.scrollHeight)
    showBackToBottom.value = false
  }

  const handleMessageScroll = () => {
    const wrap = scrollbarRef.value?.wrapRef
    if (!wrap) return

    const distanceToBottom = wrap.scrollHeight - wrap.scrollTop - wrap.clientHeight
    showBackToBottom.value = distanceToBottom > BACK_TO_BOTTOM_THRESHOLD
    const scrollingUp = wrap.scrollTop < previousScrollTop
    previousScrollTop = wrap.scrollTop
    if (scrollingUp && wrap.scrollTop <= SCROLLED_TO_TOP_THRESHOLD) onScrollToTop?.()
  }

  const handleBackToBottom = () => {
    const wrap = scrollbarRef.value?.wrapRef
    if (!wrap) return

    wrap.scrollTo({
      top: wrap.scrollHeight,
      behavior: 'smooth'
    })
    showBackToBottom.value = false
  }

  const preserveScrollPosition = async (updateContent) => {
    const wrap = scrollbarRef.value?.wrapRef
    const previousScrollHeight = wrap?.scrollHeight || 0
    const previousScrollTop = wrap?.scrollTop || 0

    updateContent()
    await nextTick()
    if (!wrap) return

    wrap.scrollTop = previousScrollTop + wrap.scrollHeight - previousScrollHeight
  }

  const resetMessageScroll = () => {
    showBackToBottom.value = false
    previousScrollTop = 0
  }

  return {
    scrollbarRef,
    showBackToBottom,
    scrollToBottom,
    handleMessageScroll,
    handleBackToBottom,
    preserveScrollPosition,
    resetMessageScroll
  }
}
